{
	"eyebrow": "Legal",
	"toc": "Índice",
	"last_updated": "Última actualización",
	"nav": {
		"label": "Páginas legales",
		"privacy": "Política de privacidad",
		"terms": "Términos y condiciones",
		"legal_notices": "Aviso legal"
	},
	"contact": {
		"title": "¿Tienes preguntas sobre estos términos?",
		"description": "Nuestro equipo estará encantado de aclarar cualquier punto de este documento. Escríbenos y te responderemos en breve.",
		"cta": "Contáctanos"
	},
	"privacy": {
		"meta": {
			"title": "Política de privacidad — UpSquad",
			"description": "Cómo UpSquad recopila, utiliza y protege tus datos personales."
		},
		"title": "Política de privacidad",
		"updated": "Fecha de entrada en vigor: 8 de marzo de 2023",
		"effective_date": "8 de marzo de 2023"
	},
	"terms": {
		"meta": {
			"title": "Términos y condiciones — UpSquad",
			"description": "Los términos que rigen tu uso de UpSquad."
		},
		"title": "Términos y condiciones",
		"updated": "Fecha de entrada en vigor: 8 de marzo de 2023",
		"effective_date": "8 de marzo de 2023"
	},
	"legal_notices": {
		"meta": {
			"title": "Aviso legal — UpSquad",
			"description": "Información de la empresa y aviso legal de UpSquad, Inc."
		},
		"title": "Aviso legal",
		"updated": "UpSquad, Inc. · Memphis, TN"
	}
}
